import { SmallButton } from '@axa-asia/emma-stylesheet';
import React, { Component } from 'react';
import './style.scss';

interface DashboardCardScenarioProps {
  imageIcon: any;
  text: string;
  buttonText?: string;
  clickButton?: () => void;
}

class DashboardCardScenario extends Component<DashboardCardScenarioProps> {
  handleClick() {
    const { clickButton } = this.props;
    clickButton && clickButton();
  }

  render() {
    const { imageIcon, text, buttonText } = this.props;
    return (
      <div className="dashboard-card-scenario-container">
        <div className="dashboard-card-scenario">
          <img src={imageIcon} className="dashboard-card-scenario-img" alt="" />
          <div className="dashboard-card-scenario-right">
            <div className="dashboard-card-scenario-text">{text}</div>
            {/* {
              buttonText && <div className="dashboard-card-scenario-button-wrap"><span className="dashboard-card-scenario-button" data-enable-ga data-ga-type="button" onClick={this.handleClick.bind(this)}>{buttonText}</span></div>
            } */}
            {buttonText && (
              <SmallButton
                data-enable-ga
                data-ga-type="button"
                onClick={this.handleClick.bind(this)}
              >
                {buttonText}
              </SmallButton>
            )}
          </div>
        </div>
      </div>
    );
  }
}

export default DashboardCardScenario;
